import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BLUE, ORANGE, Wordmark } from "./shared";

export function LandingHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const nav = [
    ["Soluzione", "#soluzione"], ["VSME", "#vsme"], ["PMI-Banche", "#pmi-banche"],
    ["JOBTIMEHR", "#jobtimehr"], ["Eva", "#eva"], ["Per chi è", "#per-chi"], ["Guide", "/guide"], ["Contatti", "#contatti"],
  ];
  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-slate-200" data-testid="landing-header">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" aria-label="ESG-PMI home"><Wordmark /></Link>
        <nav className="hidden lg:flex items-center gap-6" aria-label="Navigazione principale">
          {nav.map(([label, href]) => (
            <a key={href} href={href}
              className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
              data-testid={`nav-${label.toLowerCase().replace(/[^a-z]/g, "")}`}>
              {label}
            </a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <Link to="/login" className="text-sm font-semibold px-4 py-2 rounded-md transition-colors"
            style={{ color: BLUE }} data-testid="cta-login">
            Accedi
          </Link>
          <Link to="/richiedi-demo"
            className="text-sm font-bold px-5 py-2.5 rounded-md text-white transition-transform hover:-translate-y-0.5"
            style={{ background: ORANGE }} data-testid="cta-demo-header">
            Richiedi una demo
          </Link>
        </div>
        <button className="lg:hidden p-2" onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? "Chiudi menu" : "Apri menu"} aria-expanded={menuOpen}
          data-testid="menu-toggle">
          {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {menuOpen && (
        <nav className="lg:hidden border-t border-slate-200 bg-white px-5 py-4 space-y-1" aria-label="Menu mobile">
          {nav.map(([label, href]) => (
            <a key={href} href={href} onClick={() => setMenuOpen(false)}
              className="block py-2.5 text-sm font-medium text-slate-700"
              data-testid={`nav-mobile-${label.toLowerCase().replace(/[^a-z]/g, "")}`}>
              {label}
            </a>
          ))}
          <div className="flex gap-3 pt-3 border-t border-slate-100">
            <Link to="/login" className="flex-1 text-center text-sm font-semibold py-2.5 rounded-md border border-slate-300"
              style={{ color: BLUE }} data-testid="cta-login-mobile">Accedi</Link>
            <Link to="/richiedi-demo" className="flex-1 text-center text-sm font-bold py-2.5 rounded-md text-white"
              style={{ background: ORANGE }} data-testid="cta-demo-mobile">Richiedi demo</Link>
          </div>
        </nav>
      )}
    </header>
  );
}
